export function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var target = {};
    args.forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            target[key] = obj[key];
        });
    });
    return target;
}
export function pick(obj, keys) {
    var res = {};
    keys.forEach(function (key) {
        if (obj[key] !== void 0) {
            res[key] = obj[key];
        }
    });
    return res;
}
export function omit(obj, keys) {
    var res = {};
    Object.keys(obj).forEach(function (key) {
        if (!includes(keys, key)) {
            res[key] = obj[key];
        }
    });
    return res;
}
export function flattenObject(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
        return acc.concat(obj[key]);
    }, []);
}
export function mapValues(obj, f) {
    var res = {};
    Object.keys(obj).forEach(function (key) {
        res[key] = f(obj[key], key);
    });
    return res;
}
export function keys() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Object.keys(merge.apply(void 0, args));
}
function includes(array, item) {
    return array.indexOf(item) > -1;
}
